import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';
import { PROFILEVIEW } from 'src/app/config';

@Component({
    selector: 'app-account-details',
    templateUrl: './account-details.component.html',
    styleUrls: ['./account-details.component.css'],
    
})
export class AccountDetailsComponent implements OnInit {
  data:any;
  mobile:any;
  loader:boolean;
  page:boolean;
  baseUrl:any;
    constructor(private api: ApiService,private router: Router) { 
      
      this.api.Post(PROFILEVIEW, {}).then(data=>{
        this.page=true;
        this.loader=false;
        this.baseUrl = data['url']
        this.data=data['user'];
  }).catch(d=>{
    if( d.status == 503){
      this.api.onFail('Your session is expired please login again','Login');
      this.api.setGoto();
      this.api.setlogin(0);
      this.api.logout();
      setTimeout(() => {
      this.router.navigate(['/login']);
      },1000);
    } else{
      console.log(d);
    }
  });
  
    }
  
    ngOnInit() {
      this.loader=true;
      this.page=false;
  }
  }
